import { LocalisationService } from "@core/services/localisation.service.ts";
import { createAsyncThunk } from "@reduxjs/toolkit";

const localisationService = new LocalisationService();

interface FilterBase {
  page: number;
  size: number;
  sortBy?: string;
  sortDir?: string;
  search?: string;
}

interface FilterLocalisation extends FilterBase {
  region?: string;
  district?: string;
  commune?: string;
}

export const getAllRegions = createAsyncThunk(
  "localisation/region",
  async (filter: FilterBase) => {
    const regionists = await localisationService.getAllRegion(filter);
    return regionists;
  }
);

export const getDistrictByRegion = createAsyncThunk(
  "localisation/district",
  async (filter: FilterLocalisation) => {
    const districtList = await localisationService.getDistrict(filter);
    return districtList;
  }
);

export const getCommuneByDistrict = createAsyncThunk(
  "localisation/commune",
  async (filter: FilterLocalisation) => {
    const communeList = await localisationService.getCommune(filter);
    return communeList;
  }
);

export const getFokontanysByCommune = createAsyncThunk(
  "localisation/fokontany",
  async (filter: FilterLocalisation) => {
    const fokontanyList = await localisationService.getFokontanys(filter);
    return fokontanyList;
  }
);
